// Full Rithmic relay/connect console trace — ON for local + deployed dev + demo, OFF for prod.
// Gate: import.meta.env.MODE !== 'prod' (local='development', deployed dev='dev', demo='demo',
// prod='prod'), mirroring the CQG relay's CQG_DIAG + positionsLog.ts. Prod stays silent: Rithmic is
// dark there, and the BE structured logs (RithmicClientLog relay + server `rithmic-*` markers) are the
// telemetry surface — never the prod user's console.
export const rithmicDebug = import.meta.env.MODE !== 'prod';

type RcLevel = 'log' | 'info' | 'warn' | 'error' | 'debug';

function emit(level: RcLevel, args: unknown[]): void {
  if (!rithmicDebug) return;
  // 'debug' → console.log so the full frame-level trace is visible WITHOUT the browser's Verbose filter
  // (that's the "full logs" ask); every other level maps 1:1.
  const sink = level === 'debug' ? console.log : console[level];
  sink(...args);
}

/**
 * Drop-in gated console for the Rithmic feature. Use exactly like `console.*` (ts()-prefixed lines,
 * objects, format strings all pass through). No-op in prod; full output on local/dev/demo.
 */
export const rc = {
  log:   (...args: unknown[]) => emit('log', args),
  info:  (...args: unknown[]) => emit('info', args),
  warn:  (...args: unknown[]) => emit('warn', args),
  error: (...args: unknown[]) => emit('error', args),
  debug: (...args: unknown[]) => emit('debug', args),
};
